import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMatomoPageView } from '../utils/matomo';

export const useAnalyticsPageView = (): void => {
    const location = useLocation();

    useEffect(() => {
        trackMatomoPageView(`${location.pathname}${location.search}`);
    }, [location]);
};
